import toastr from 'toastr'
import layout from 'layouts/default'
import {dateTime} from 'services'
import placesAutocomplete from 'components/placesAutocomplete'
import switchBtn from 'components/switchBtn'
import googleMapsMovableMarker from 'components/googleMapsMovableMarker'
import sSelect from 'components/sSelect'
import moment from 'moment'

const directives = {
}

const components = {
  layout,
  placesAutocomplete,
  switchBtn,
  googleMapsMovableMarker,
  sSelect
}

const methods = {
  onLocationChanged (location) {
    this.formData.latitude = location.lat;
    this.formData.longitude = location.lng;
  },

  selectedPortOption (options, value) {
    if (value === null || typeof value === 'undefined' || value === '') {
      return {};
    }
    return _.find(options, option => option.value === value) || {value, text: value};
  },

  setPortCode (option) {
    this.$set(this.formData, 'port_code', option && option.value ? option.value : null);
  },

  setPortName (option) {
    this.$set(this.formData, 'port_name', option && option.value ? option.value : null);
  },

  defaultPortCodeType (portType) {
    if (portType === 'airport') {
      return 'iata';
    }
    if (portType === 'seaport') {
      return 'unlocode';
    }
    return null;
  },

  applyDefaultPortCodeType () {
    const portCodeType = this.defaultPortCodeType(this.formData.port_type);
    if (portCodeType) {
      this.$set(this.formData, 'port_code_type', portCodeType);
    }
  },

  findAirportBy (field, value) {
    const key = String(value || '').trim().toLowerCase();
    if (!key) {
      return null;
    }
    return _.find(this.airports, (airport) => {
      return String(airport[field] || '').trim().toLowerCase() === key;
    }) || null;
  },

  syncPortFields (matchField, airportField, formField, value) {
    if (!this.portAutoFillReady || this.syncingPortFields) {
      return;
    }

    const airport = this.findAirportBy(matchField, value);
    if (!airport || !airport[airportField] || this.formData[formField] === airport[airportField]) {
      return;
    }

    this.syncingPortFields = true;
    this.$set(this.formData, formField, airport[airportField]);
    this.$nextTick(() => {
      this.syncingPortFields = false;
    });
  },

  fetchAirports () {
    return this.$store.dispatch('dashboards.getAirports').then(() => {
      const data = _.cloneDeep(this.$store.state.dashboards.airports);
      if (Array.isArray(data)) {
        this.airports = data;
      } else if (data && Array.isArray(data.airports)) {
        this.airports = data.airports;
      } else if (data && Array.isArray(data.data)) {
        this.airports = data.data;
      } else {
        this.airports = [];
      }
    }).catch(() => {
      this.airports = [];
    });
  },
  onSubmitFom () {
    this.errors = {}
    this.submit_loading = true;

    if (this.formData.state_id == "") {
      this.formData.state_id = null;
    }

    this.$store.dispatch('locations.add', _.cloneDeep(this.formData)).then(() => {
      this.submit_loading = false;
      if (this.$store.state.locations.errors) {
        this.errors = _.cloneDeep(this.$store.state.locations.errors.errors);
        toastr.error(this.$store.state.locations.errors.message);
      } else {
        toastr.success('A new location has been created');

        this.formData = {
          name: null,
          phone: null,
          address: null,
          number_of_rooms: null,
          number_of_parkings: null,
          country_id: "",
          state_id: ""
        }

        this.$router.push({name: 'locations.edit', params: {
          id: this.$store.state.locations.active.id
        }});
      }
    })
  }
}

const computed = {
  countries () {
    return [{name: "Select Country", id: null}].concat(this.$store.state.address.countries);
  },
  states () {
    let states = [{name: "Select State", id: ""}];
    if (this.formData.country_id) {

      let indx = _.findIndex(this.countries, item => item.id == this.formData.country_id);
      if (indx > -1) {
        states = states.concat(this.countries[indx].states);
      }
    }

    return states;
  },
  currencies () {
    return [].concat(this.$store.state.currencies.all);
  },

  timezones () {
    return [{name: "Select Timezone", id: null}].concat(this.$store.state.timezones.all);
  },
  portCodeOptions () {
    return [{value: null, text: '-- Select Port Code --'}].concat(
      _.map(this.airports, (airport) => {
        return {
          value: airport.iata_code,
          text: airport.iata_code
        };
      })
    );
  },
  portNameOptions () {
    return [{value: null, text: '-- Select Port Name --'}].concat(
      _.map(this.airports, (airport) => {
        return {
          value: airport.airport_name,
          text: airport.airport_name
        };
      })
    );
  },
  selectedPortCode () {
    return this.selectedPortOption(this.portCodeOptions, this.formData.port_code);
  },
  selectedPortName () {
    return this.selectedPortOption(this.portNameOptions, this.formData.port_name);
  },
  center () {
    if (this.googlePlace) {
      let location = {
        lat: this.googlePlace.geometry.location.lat(),
        lng: this.googlePlace.geometry.location.lng()
      };
      this.formData.latitude = this.googlePlace.geometry.location.lat();
      this.formData.longitude = this.googlePlace.geometry.location.lng();
      this.googlePlace = null;
      return location;
    } else if (this.formData.latitude && this.formData.longitude) {
      let location = {
        lat: parseFloat(this.formData.latitude),
        lng: parseFloat(this.formData.longitude)
      };
      return location;
    }

    return null
  },
}

const data = {
  loading: false,
  submit_loading: false,
  errors: {},
  googlePlace: null,
  formData: {
    name: null,
    phone: null,
    address: null,
    port_type: "airport",
    port_code_type: "iata",
    port_code: null,
    port_name: null,
    number_of_rooms: null,
    number_of_parkings: null,
    country_id: null,
    state_id: null,
    timezone_id: null,
    checkin_time:null,
    checkout_time:null,
    latitude: null,
    longitude: null,
  },
  times: dateTime.getHalfHours(),
  airports: [],
  portAutoFillReady: false,
  syncingPortFields: false,
}

export default {
  name: 'new-location',
  components,
  methods,
  computed,
  directives,
  data () {
    return data
  },
  watch: {
    'formData.port_type' () {
      this.applyDefaultPortCodeType();
    },
    'formData.port_code' (value) {
      this.syncPortFields('iata_code', 'airport_name', 'port_name', value);
    },
    'formData.port_name' (value) {
      this.syncPortFields('airport_name', 'iata_code', 'port_code', value);
    },
  },
  created () {
    this.$store.dispatch('address.getCountries');
    this.$store.dispatch('currencies.getAll');
    this.$store.dispatch('timezones.getAll');
    this.fetchAirports().then(() => {
      this.$nextTick(() => {
        this.portAutoFillReady = true;
      });
    });
  }
}
